import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'
import {Markdown} from 'components/Markdown'

export class ProblemsSolved extends Component {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () =>
    <div className={this.props.className}>
      <div className={styles.detail}>
        <Markdown mdtext={this.props.dealSheet.problemBeingSolved}/>
      </div>
    </div>
}

const styles = StyleSheet({
  detail: {
    fontSize: '13px',
    lineHeight: '20px',
    paddingRight: 75,
    marginBottom: 50,
  }
})

export default ProblemsSolved